export const PC_MEGA_MENU_ITEM_LIMIT = 12;

export const getVisibleMegaMenuItems = <T>(items: readonly T[]): readonly T[] =>
  items.slice(0, PC_MEGA_MENU_ITEM_LIMIT);
